import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "fileInput",
    "filePreview",
    "importButton",
    "mappingForm",
    "chooseFileButton",
    "contentSection",
    "importSection",
    "exportSection",
    "spinner",
    "infoSection",
    "submitButton",
    "formContent"
  ]

  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get("show_import_modal") === "1") {
      this.open()
    }
  }

  updateFilePreview(event) {
    const file = event.target.files[0]
    if (!file) return this.reset()

    this.filePreviewTarget.innerHTML = `
      <div class="flex items-center justify-between">
        <p class="text-sm text-gray-700 font-medium">${file.name}</p>
        <button type="button"
                data-action="click->field-mapping#reset"
                class="text-sm text-red-600 underline mt-2">
          Remove file
        </button>
      </div>
    `

    this.chooseFileButtonTarget.classList.add("hidden")
    this.contentSectionTarget.classList.remove("md:grid-cols-2")
    this.filePreviewTarget.classList.remove("hidden")
    this.importButtonTarget.classList.remove("hidden")
    this.infoSectionTarget.classList.remove("hidden")
    this.importSectionTarget.classList.add("md:col-span-2")
    this.exportSectionTarget.classList.add("hidden")
    
  }

  showMappingForm() {
    this.importButtonTarget.classList.add("hidden")
    this.mappingFormTarget.classList.remove("hidden")
  }

  startImport(event) {
    if (this.isSubmitting) return
    this.isSubmitting = true

    this.mappingFormTarget.classList.add("opacity-50", "pointer-events-none")
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.add("hidden")
    }
    if (this.hasFormContentTarget) {
      this.formContentTarget.classList.add("hidden")
    }

    requestAnimationFrame(() => {
      this.spinnerTarget.classList.remove("hidden")
      this.filePreviewTarget.classList.add("hidden")
    })
  }
  
  reset() {
    window.location.href = `${window.location.pathname}?show_import_modal=1`
  }
}
